import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'

function PaymentsListItem({ item }) {
  return (
    <tr key={item.id}>
      <td>
        <div className="wrapper-post-title">
          <div className="post-title">{item.client?.name || '---'}</div>
        </div>
      </td>
      <td>{item.code}</td>
      <td>
        <span className="datetime">{moment(item.updatedAt).format('L [às] LT')}</span>
      </td>
    </tr>
  )
}

PaymentsListItem.protoTypes = {
  item: PropTypes.objectOf(PropTypes.object).isRequired
}

export default PaymentsListItem
